import { render, staticRenderFns } from "./schoolSpace.vue?vue&type=template&id=493e5bc1&scoped=true"
import script from "./schoolSpace.vue?vue&type=script&lang=js"
export * from "./schoolSpace.vue?vue&type=script&lang=js"
import style0 from "./schoolSpace.vue?vue&type=style&index=0&id=493e5bc1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493e5bc1",
  null
  
)

export default component.exports